import BaseApiService from "../BaseApiService";

interface UpdateScanCountResponse {
	data: {
		sku: string;
		name: string;
	};
	meta: {};
}

export default class ScanCounts extends BaseApiService {
	private static instance: ScanCounts;
	private baseUrl: string;

	private constructor() {
		super();
		this.baseUrl = process.env["REACT_APP_API_URL"]!.concat("/api/scan-counts");
		ScanCounts.instance = this;
	}

	public static getInstance() {
		if (!ScanCounts.instance) return new this();
		return ScanCounts.instance;
	}

	public async add(sku: string, name: string): Promise<UpdateScanCountResponse> {
		const path = this.baseUrl;
		try {
			return await this.postRequest(path, { data: { sku, name } }, { Authorization: `Bearer ${process.env["REACT_APP_API_KEY"]}` });
		} catch (err) {
			return this.onError(err);
		}
	}
}
